<template>
  <div id="broadcast-info">
    <div ref="fill-header" class="flow-text px-3">
      <v-layout row>
        <v-flex xs12 v-if="user && user.userType === 'teacher'">
					<h1 class='text-xs-center'>Broadcast: {{bulb.name}}</h1>
					<h3 class='text-xs-center' v-if="bulb.learningObjective">{{bulb.learningObjective}}</h3>
					<br/>
					<p v-if="user.isLti">Learners should launch this broadcast {{termForBulb}} through their LMS.</p>
					<div v-else>
      		  <p class='text-xs-center'>Have learners join using the URL below or code: <span class='text-bold'>{{broadcastId}}</span></p>
      			<div class="copy-container">
              <v-text-field  box hide-details readonly :value="broadcastUrl"></v-text-field>
              <v-btn v-if='!copied' class="ma-0 copy-button" column small flat @click="copyValue(broadcastUrl)">
                Copy
              </v-btn>
              <div v-if="copied">
                <v-btn  class="ma-0 copy-confirm" column small flat color='white'>Copied</v-btn>
              </div>
            </div>
            
          <div class="advanced-container">
              <v-switch
                v-if="hasSchoolId"
                v-model="share.pd"
                label="Assign for Professional Learning"
                hide-details
                :disabled="share.authenticate"
              >
              </v-switch>
              <v-switch
                v-if="hasSamlLogin"
                v-model="share.samlLogin"
                @change="handleSAMLOrAuthToggled('saml')"
                label="Require SAML login"
                hide-details>
              </v-switch>
              <v-switch
                v-model="share.authenticate"
                label="Do not require login"
                @change="handleSAMLOrAuthToggled('auth')"
                hide-details
                :disabled="share.pd">
              </v-switch>
              <v-switch
               v-model="share.name"
               label="Do not require learner name"
               hide-details
               :disabled=" !share.authenticate">
              </v-switch>
              <v-switch
               v-if="!user.isLti"
               v-model="showQRCode"
               @change="createQRCode"
               hide-details
               label="Show QR Code">
              </v-switch>
              <Tooltip
                v-if="showQRCode"
                right
                tag="div">
                <canvas v-if="showQRCode" id="qrCode" @click="copyQRCode"></canvas>
                <template v-slot:text>
                  Click to copy QR Code.
                </template>
              </Tooltip>
          </div>
        
					</div>
					<p class='text-xs-center'>
						<v-btn
              v-if="showBroadcastStartBtn || !broadcastInitialized"
							large
							color='primary'
							id="initialize-broadcast"
							role='button'
							aria-label='Start broadcast'
							column
              :disabled="startDisable"
							@click='initializeBroadcastSession' >
								Start
						</v-btn>
						<v-btn
							large
							class="floating-btn theme--light primary--text"
							id="list-learners"
							role='button'
							aria-label='List learners'
							column
							@click='broadcastShowLearners' >
								List Learners ({{broadcastLearnersCount}})
						</v-btn>
					</p>
          <v-list v-show="broadcastShowLearner">
            <span class='text-bold'>Show learners who started within last <input type="number" v-model="learnerMinRange" value='60' min="1" max="120" style="padding-left: 10px;"/> minutes </span>
            <v-subheader inset>Active Students</v-subheader>
            <template v-for="learner in filterBroadcastLearners">
              <v-list-tile
                :key="learner.learnerId"
                avatar
                @click=""
                >
                <v-list-tile-action>
                  <v-icon :color="(learner.data && learner.data.status === 'online' && statusTimeDifference(learner.data.updated) < 3 ? 'blue' : 'grey')">visibility</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="learner.learnerDetails && (learner.learnerDetails.firstName + ' '+learner.learnerDetails.lastName) + ' - ' + getLernerUpdateTime(learner.updated)"></v-list-tile-title>
                </v-list-tile-content>
                <!-- <v-list-tile-avatar>
                  <img :src="item.avatar">
                </v-list-tile-avatar> -->
              </v-list-tile>
              <v-divider></v-divider>
            </template>
          </v-list>
				</v-flex>
        <v-flex xs12 v-if="user && user.userType === 'student'">
					<h1 class='text-xs-center'>Broadcast: {{bulb.name}}</h1>
					<h3 class='text-xs-center' v-if="bulb.learningObjective">{{bulb.learningObjective}}</h3>
					<br/>
					<p>Wait for instructor to push questions. You will need to answer them before the instructor removes them from screen.</p>
					<p><span class='text-bold'>Note:</span>Click "Fetch Question" if question does not appear automatically.</p>
					<p class='text-xs-center'>
						<v-btn
						  tabindex = 0
              v-if="broadcastInitialized"
							large
							color='primary'
							id="initialize-broadcast"
							role='button'
							aria-label='Fetch Question'
							column
              v-show="!(broadcastTeacherStatus && broadcastTeacherStatus==='complete')"
							@click='fetchQuestionFromBroadcast' >
								Fetch Question
						</v-btn>
						<v-btn
              v-if="broadcastInitialized"
							large
							class="floating-btn theme--light primary--text"
							role='button'
							aria-live='polite'
              v-show="!(broadcastTeacherStatus && broadcastTeacherStatus==='complete')"
							column >
								{{instructorStatusString}}
						</v-btn>
					</p>
				</v-flex>
      </v-layout>
    </div>
    <div class="broadcast-info-wrapper">

    </div>
  </div>
</template>

<script>
/* global _ */
/* global dataLayer, navigator, ClipboardItem */

// Components
import EventBus from '@/buses/EventBus';

// Plugins / Libraries
import _ from 'lodash';
import moment from 'moment';
import QRCode from 'qrcode';

import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';

import {
  triggerInstructorStatus,
  triggerInteractionItems,
  getCurrentInteractionFromFirestore,
} from '@/js/firestore-utils';

export default {
  name: 'broadcast-info',
  data () {
    return {
      broadcastInitialized: false,
      startDisable: false,
      loadingBroadcast: false,
      broadcastShowLearner: false,
      copied: false,
      filterBroadcastLearners: [],
      share: {
        pd: false,
        authenticate: false,
        name: false,
        samlLogin: false,
      },
      showQRCode: false,
      learnerMinRange: 60,
    }
  },
  computed: {
    ...mapState('player', [
			'playButtonClicked', // indication if the user has explicitly clicked our videojs player big blue play button.
  	]),
    ...mapGetters('player', [
      'phpApiPrefix',
  		'bulb',
      'bulbInitialized',
      'sidezoneOpen',
      'broadcastId',
      'broadcastLearners',
      'broadcastTeacherStatus',
      'user',
      'showBroadcastStartBtn',
      'termForBulb',
    ]),
    broadcastLearnersCount() {
      if(this.broadcastLearners) {
        const activeStudents = _.filter(this.broadcastLearners, (learner) => learner.data && learner.data.status === 'online' && this.statusTimeDifference(learner.data.updated) < 3);
        if(activeStudents) return activeStudents.length;
      }
      return 0;
    },
    broadcastUrl() {
      if (!this.share.authenticate) {
        this.share.name = false;
      }
      if (this.share.pd) {
        return this.share.samlLogin ? 
        `${this.phpApiPrefix}/saml/${this.school.id}?redirect=/broadcast-v3/${this.broadcastId}/professional`
        : `${this.phpApiPrefix}/broadcast-v3/${this.broadcastId}/professional`;
      }
      if (this.share.samlLogin) {
        return `${this.phpApiPrefix}/saml/${this.school.id}?redirect=/broadcast-v3/${this.broadcastId}`
      } else if (!this.share.authenticate && !this.share.name) {
        return  `${this.phpApiPrefix}/broadcast-v3/${this.broadcastId}`;
      } else if (this.share.authenticate && !this.share.name) {
        return  `${this.phpApiPrefix}/broadcast-v3/${this.broadcastId}/listcode/0`;
      } else if (this.share.authenticate && this.share.name) {
        return  `${this.phpApiPrefix}/broadcast-v3/${this.broadcastId}/listcode/2`;
      }
    },
    hasSamlLogin() {
      return _.get(this.bulb, 'masterTeacher.school.permissionKeys', []).includes('hasSamlLogin');
    },
    instructorStatusString() {
      return `Instructor is ${this.broadcastTeacherStatus}`;
    },
    school() {
      return _.get(this.bulb, 'masterTeacher.school', null);
    },
    hasSchoolId() {
      return this?.bulb?.teachers[0]?.school?.id;
    },
  },
  methods: {
    ...mapMutations('player', [
      'setInitializingBulb',
      'setPlayButtonClicked',
      'setSidebarOpen',
      'setSidezoneOpen',
      'setSnackbar',
      'setShowBroadcastStartBtn',
    ]),
    copyValue: function(str){
      //copy share or embed url
      navigator.clipboard.writeText(str);
      this.copyConfirm();
    },
    copyConfirm: function(){
      this.copied = true;
      setTimeout(() => {
        this.copied = false
      }, 1000);
    },
    async copyQRCode() {
      const canvas = document.getElementById('qrCode');
      canvas.toBlob((blob) => {
        let data = [new ClipboardItem({ [blob.type]: blob })];
        navigator.clipboard.write(data).then(() => {
          this.setSnackbar({
            text: 'QR Code copied!',
            color: 'success',
            timeout: 5000,
          });
        }, function (err) {
          throw err;
        });
      });
    },
    async createQRCode() {
      try {
        await this.$nextTick();
        const qrElement = document.getElementById('qrCode');
        await QRCode.toCanvas(qrElement, this.broadcastUrl, {
          errorCorrectionLevel: 'H',
        });
      } catch (err) {
        const qrElement = document.getElementById('qrCode');
        qrElement.style.display = 'none';
        console.error(err);
      }
    },
    handleSAMLOrAuthToggled(type) {
      if (
        type === 'saml'
        && this.share.samlLogin
      ) {
        this.share.authenticate = false;
        this.share.name = false;
      } else if (type === 'auth') {
        this.share.samlLogin = false;
      }
    },
    initializeBroadcastSession() {
      /**
  		 * browsers at least one user click action before videos will play
  		 * this method tracks that user click has been preformed
  		 */
   		this.setShowBroadcastStartBtn(false);
      this.setPlayButtonClicked(true);
      if(this.bulbInitialized) { 
        this.startDisable = true;
        this.setSidezoneOpen(!this.sidezoneOpen);
        this.setSidebarOpen(this.sidezoneOpen);
  		}
      if(!this.initializing && !this.bulbInitialized) this.setInitializingBulb(true);
      if (this.$store.state.mobile) {
				EventBus.$emit('requestAction', { key: 'play', forceToAll: true, setDesiredState: true });
			} else {
				EventBus.$emit('requestAction', { key: 'play', setDesiredState: true });
			}
      triggerInstructorStatus(this.broadcastId, 'ready');
      triggerInteractionItems(this.broadcastId, 0, null);
    },

    broadcastShowLearners() {
      this.broadcastShowLearner = !this.broadcastShowLearner;
    },

    fetchQuestionFromBroadcast() {
      const self = this;
      getCurrentInteractionFromFirestore(this.broadcastId).then(data => {
        self.$store.commit('player/setBroadcastDisplayTime', data.displayTime);
				self.$nextTick(() => { self.$store.commit('player/setBroadcastActiveInteractionId', data.interaction_id); });
      })
      .catch(err => {
        self.setSnackbar({
          text: `No question on instructor side.`,
          color: 'warning'
        });
      });
    },

    statusTimeDifference(time) {
      return Math.abs(moment(time).utc().diff(moment().utc(), 'hours'));
    },
    getLernerUpdateTime(time) {
      return `joined ${moment(time).fromNow()}`;
    },
  },
  watch: {
    'bulbInitialized'(n, o) {
      if(this.bulbInitialized) {
        this.broadcastInitialized = true;
        if(this.user && this.user.userType === 'teacher') {
          this.setSidezoneOpen(!this.sidezoneOpen);
          this.setSidebarOpen(this.sidezoneOpen);
        }
      }
    },
    'learnerMinRange'(n, o) {
      if(n > 120) this.learnerMinRange = 120;
      if(!n) this.learnerMinRange = 0;
      if(n != 0) {
        const filterMinDate = moment().subtract(n, "minutes").toDate();
        this.filterBroadcastLearners = _.filter(this.broadcastLearners, (learner) => moment(learner.updated) > moment(filterMinDate) );
      } else {
        this.filterBroadcastLearners = [...this.broadcastLearners];
      }

    },
    'broadcastLearners'(n, o) {
      const filterMinDate = moment().subtract(60, "minutes").toDate();
      this.filterBroadcastLearners = _.filter(this.broadcastLearners, (learner) => moment(learner.updated) > moment(filterMinDate) );
    },
    'broadcastUrl' (n, o) {
      if (n) this.createQRCode();
    },
  },
  mounted() {
    if(this.user && this.user.userType === 'student') {
      this.broadcastInitialized = true;
    }
    this.share.samlLogin = _.get(this.school, 'config.enableSamlByDefault', false);
  }
};
</script>

<style>
  #broadcast-info{
    display:flex;
    flex-direction: column;
    min-height: 0;
    flex-grow: 1;
    overflow: auto;
    background: #fff;
    border-radius:2px;
  }
  .broadcast-info-wrapper {
    height: 100%;
    position:relative;
    overflow: hidden;
  }

  .broadcast-info-subheader{
    text-align: center;
  }
  .discussion-form {
    min-height: 100px;
    display: flex;
    max-width:100%;
    align-items: flex-start;
    padding-top: 5px;
  }

  .discussion-form .form-left {
    width: 80%;
  }

  .input-group {
    padding: 18px 0 0;
  }
  .input-group label {
    height: 30px;
  }

  .v-input-group__details {
    display: block;
  }

  .captions-wrapper .more-messages-below {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 0.5rem 0;
    background: rgba(0,0,0,0.6);
    color: white;
    user-select: none;
    cursor: pointer;
  }

  .loading-screen {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    background-color: rgba(255,255,255,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ppcaption {
    margin: 0 2.5%;
    padding: 0 10px;
  }

  .ppcaption .caption-content {
    word-wrap: break-word;
    white-space: normal;
  }

  .ppcaption .caption-content:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  .ppcaption a.replies-button {
    color: rgba(0,0,0,0.8);
    user-select: none;
    font-weight: 500;
  }

  .comment-actions a:not(:last-of-type) {
    margin-right: 8px;
  }

  .comment-actions .v-btn .v-btn__content {
    padding: 0;
    transition: none;
  }

  .ppcaption {
    border-left: 2px solid transparent;
  }

  .ppcaption img {
    max-width: 100%;
  }

  .ppcaption a:hover {
    color: rgba(17,17,17,0.8) !important;
    font-weight: 700;
  }

  .ppcaption a.replies-button:hover {
    color: rgba(17,17,17,0.8) !important;
    font-weight: 500;
  }

  .caption-header-text {
    font-size: 25.2px;
    font-weight: 300;
    white-space: normal;
  }
  
  .advanced-container {
    padding: 24px 24px 24px 24px;
  }

  .advanced-container .v-label {
    font-size: 14px !important;
  }

  .copy-button {
    flex: 0 0 auto;
    height: 40px !important;
  }

  .copy-container{
    display: flex;
  }
  
  .copy-container input {
    margin-top: 6px;
    outline: none!important;
  }
  
  .copy-container .v-input {
    flex: 1 0 auto;
  }
  
  .copy-container .v-input__control, .copy-container .v-input__slot {
    height: 40px !important;
    min-height: 40px !important;
  }

  .copy-container .v-input_control:before , .copy-container .v-input__slot:before {
    border: none !important;
  }

  .copy-confirm {
    flex: 0 0 auto;
    height: 40px !important;
    color:#fff;
    background-color: #4CAE51;
  }

  #initialize-broadcast {
		opacity: 0.8;
		background-color: #1B5E20 !important;
		flex-direction: column;
	}
	#initialize-broadcast:hover {
		opacity: 1; }
  span.text-bold { font-weight: bold; }
  @media only screen and (min-width: 960px) {
    .hide--mobile { display: none; }
  }
  
  .floating-btn.v-btn {
  align-items: center;
  border-radius: 2px;
  display: inline-flex;
  font-weight: 400;
  justify-content: center;
  outline: 0;
  text-transform: uppercase;
  text-decoration: none;
  transition: .3s cubic-bezier(.25,.8,.5,1),color 1ms;
  vertical-align: middle;
  border: 1px solid;
  box-shadow: none;
  min-width: 88px;
  user-select: none;
  background: white !important;
  z-index: 1001;
}

.floating-btn.v-btn :hover {
  box-shadow: none;
}

canvas:hover {
  cursor: pointer;
}
</style>
